var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BootstrapVueTable',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"search":false,"items":_vm.table_data,"fields":_vm.table_fields}})}
var staticRenderFns = []

export { render, staticRenderFns }